// extracted by mini-css-extract-plugin
export var borderRadius = "_ge-4";
export var large = "_ge-3";
export var logoContainer = "_ge-0";
export var nameLogo = "_ge-2";
export var small = "_ge-1";